import React from 'react';
import './PlanCalculationContent.css';
import TestimonialCard from '../../../components/TestimonialCard';

interface Testimonial {
    avatar: string;
    name: string;
    rating: number;
    text: string;
}

export interface PlanCalculationContentProps {
    title: string;
    subtitle: string;
    testimonials: Testimonial[];
    step: any;
}

export const PlanCalculationContent: React.FC<PlanCalculationContentProps> = ({
    title,
    subtitle,
    testimonials
}) => {
    return (
        <div className="plan-calculation">
            <div className="plan-calculation__header">
                <div className="plan-calculation__spinner">
                    <svg viewBox="0 0 50 50" className="plan-calculation__spinner-svg">
                        {[...Array(12)].map((_, i) => (
                            <circle
                                key={i}
                                cx="25"
                                cy="25"
                                r="2"
                                style={{
                                    transform: `rotate(${i * 30}deg)`,
                                    transformOrigin: '25px 25px',
                                    opacity: 1 - (i * 0.08)
                                }}
                            />
                        ))}
                    </svg>
                </div>
                <h1 className="plan-calculation__title">{title}</h1>
                <p className="plan-calculation__subtitle">{subtitle}</p>
                <div className="plan-calculation__progress">
                    <div className="plan-calculation__progress-bar">
                        <div className="plan-calculation__progress-fill" />
                    </div>
                </div>
            </div>

            <div className="plan-calculation__testimonials">
                <h2 className="plan-calculation__testimonials-title">
                    What others say about their journey
                </h2>
                <div className="plan-calculation__testimonials-list">
                    {testimonials.map((testimonial, index) => (
                        <TestimonialCard key={index} avatar={testimonial.avatar} name={testimonial.name} rating={testimonial.rating} text={testimonial.text} />
                    ))}
                </div>
                <div className="plan-calculation__testimonials-dots">
                    {testimonials.map((_, index) => (
                        <span
                            key={index}
                            className={`plan-calculation__testimonials-dot ${
                                index === 0 ? 'plan-calculation__testimonials-dot--active' : ''
                            }`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};
